import {subdebug} from '@sanity/cli-core'

export const importMediaDebug = subdebug('media:import')
